export const Styles: any = {
  ".successMessage": {
    "background": "var(--color-status-success-fill) !important",
    "color": "#191919 !important",
    ".ms-MessageBar-content": {
      background: "var(--color-surface-muted) !important",
      color: "var(--color-fg-1) !important",
    },
  },
  ".errorMessage": {
    "background": "var(--color-surface-muted) !important",
    "color": "#191919 !important",
    ".ms-MessageBar-content": {
      background: "var(--color-surface-muted) !important",
      color: "var(--color-fg-1) !important",
    },
  },
  ".warningMessage": {
    "background": "var(--color-brand-70) !important",
    "color": "#000000 !important",
    ".ms-MessageBar-content": {
      background: "var(--color-brand-70) !important",
      color: "var(--color-fg-1) !important",
    },
  },
  "messageStack": (MessageBarType: string) => {
    return {
      root: {
        "minHeight": "36px",
        "background": "var(--color-status-success-fill) !important",
        "color": MessageBarType === "warning" ? "#000000 !important" : "#191919 !important",
        ".ms-MessageBar-content": {
          "background":
            MessageBarType === "success"
              ? "var(--color-status-success-fill) !important"
              : MessageBarType === "error"
                ? "var(--color-fg-danger-soft) !important"
                : "var(--color-brand-70) !important",
          "color": MessageBarType === "warning" ? "#000000 !important" : "#191919 !important",
          "alignItems": "center",
          ".ms-MessageBar-icon": {
            i: {
              color: MessageBarType === "warning" ? "#000000 !important" : "#191919 !important",
            },
          },
          ".ms-MessageBar-text": {
            "fontSize": "14px",
            "lineHeight": "18px",
            ".ms-MessageBar-innerText": {
              "width": "100%",
              "whiteSpace": "unset",
              ".ms-Stack": {
                justifyContent: "space-between",
              },
            },
          },
        },
      },
    };
  },
  "messageBar": {
    display: "none",
    backgroundColor: "transparent",
    borderRadius: "2px",
    minHeight: "36px",
  },
  "notificationMessage": {
    display: "flex",
    alignItems: "center",
  },
  "messageBarOn": {
    backgroundColor: "transparent",
    borderRadius: "2px",
    minHeight: "36px",
  },
};
